import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ViewChild,
  Input
} from '@angular/core';

@Component({
  styleUrls: ['./ende.component.scss'],
  templateUrl: './ende.component.html'
})
export class PageEndeComponent {}



// WEBPACK FOOTER //
// ./src/app/pages/ende/ende.component.ts